import { createAsyncThunk, createSelector, createSlice } from "@reduxjs/toolkit";
import makeAjaxRequest from "helpers/makeAjaxRequest";
import { rosterNumUrl, rosterUrl, sitesUrl } from "../actions/constants";

const providerState = state => state.institutionProviders;

export const selectProvider = createSelector(
  [providerState],
  (institutionState) => institutionState.providers
);

export const selectCredentials = createSelector(
  [providerState],
  (institutionState) => institutionState.credentials
);
export const selectedProvider = createSelector(
  [providerState],
  (institutionState) => institutionState.selectedProvider
);
export const selectedProviderId = createSelector(
  [providerState],
  (institutionState) => institutionState.selectedProvider?.providerCtepId
);
export const associatedProvider = createSelector(
  [providerState],
  (institutionState) => institutionState.associatedProvider
);

export const fetchInstitutionProvidersData = createAsyncThunk(
  "institution/fetchProviders",
  async (Ognid, { rejectWithValue }) => {
    try {
      const response = await makeAjaxRequest.postWithAuth(`${rosterUrl}/id/${Ognid}/providers`, {});
      const data = response.data[0];
      return { providers: response, selectedProvider: data };
    } catch (err) {
      return rejectWithValue(err.response ? err.response.data : err.message);
    }
  }
);

export const fetchInstitutionCredentialsData = createAsyncThunk(
  "institution/fetchCredentials",
  async (providerCtepId, { rejectWithValue }) => {
    try {
      const response = await makeAjaxRequest.postWithAuth(`${sitesUrl}/${providerCtepId}/credentials`, {});

      return { credentials: response };
    } catch (err) {
      return rejectWithValue(err.response ? err.response.data : err.message);
    }
  }
);
export const saveSelectedInstitutionProvider = createAsyncThunk(
  "institution/saveProvider",
  async (data, { rejectWithValue }) => {
    try {
      const credentialsResponse = await makeAjaxRequest.postWithAuth(
        `${sitesUrl}/${data.providerCtepId}/credentials`,
        {}
      );
      return { selectedProvider: data, credentials: credentialsResponse };
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);
export const fetchInstitutionAssociatedProviders = createAsyncThunk(
  "institution/fetchAssociatedProviders",
  async (irostId, { rejectWithValue }) => {
    try {
      const response = await makeAjaxRequest.postWithAuth(`${rosterNumUrl}/${irostId}/associated/providers`, {});
      return { associatedProvider: response, selectedProvider: { providerCtepId: irostId } };
    } catch (err) {
      return rejectWithValue(err.response ? err.response.data : err.message);
    }
  }
);
const providerSlice = createSlice({
  name: "institution",
  initialState: { providers: [], credentials: [] },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchInstitutionProvidersData.fulfilled, (state, action) => {
      state.providers = action.payload.providers;
      state.selectedProvider = action.payload.selectedProvider;
    });
    builder.addCase(fetchInstitutionCredentialsData.fulfilled, (state, action) => {
      state.credentials = action.payload.credentials;
    });
    builder.addCase(saveSelectedInstitutionProvider.fulfilled, (state, action) => {
      state.selectedProvider = action.payload.selectedProvider;
      state.credentials = action.payload.credentials;
    });
    builder.addCase(fetchInstitutionAssociatedProviders.fulfilled, (state, action) => {
      state.associatedProvider = action.payload.associatedProvider;
      state.selectedProvider = action.payload.selectedProvider;
    });
  }
});

export default providerSlice.reducer;
